import { useNavigate } from "../router";

export const Products = (props) => {
  const navigate = useNavigate();

  const openDetailPage = (product) => {
    if (!product?.slug) return;
    navigate(`/product/${product.slug}`, { state: { item: product } });
  };

  return (
    <div id='products' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Products</h2>
        </div>
        <div className='feature-grid'>
          {props.data
            ? props.data.map((d, i) => (
                (() => {
                  const hasImage = Boolean(d.image);
                  const bgStyle = hasImage
                    ? {
                        backgroundImage: `linear-gradient(90deg, rgba(4,16,26,0.9) 0%, rgba(4,16,26,0.8) 40%, rgba(4,16,26,0.65) 100%), url('${d.image}')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }
                    : {
                        backgroundImage: "linear-gradient(145deg, var(--panel), var(--panel-2))",
                      };
                  return (
                <div
                  key={`${d.title}-${i}`}
                  className={`service-card product-card ${hasImage ? 'product-card-hero' : ''}`}
                  role="button"
                  tabIndex={0}
                  onClick={() => openDetailPage(d)}
                  onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && openDetailPage(d)}
                  style={bgStyle}
                >
                  <div className="product-card-overlay">
                    <h3>{d.title}</h3>
                    <p>{d.text}</p>
                    <span className="learn-more">Learn More →</span>
                  </div>
                </div>
                  );
                })()
              ))
            : 'Loading...'}
        </div>
      </div>
    </div>
  )
}
